import { render } from "./add-card.vue?vue&type=template&id=b97ed476&lang=pug"
import script from "./add-card.vue?vue&type=script&lang=js"
export * from "./add-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__